import React from "react";
import { CheckCircleOutlined, HomeOutlined, InboxOutlined, LoadingOutlined, StopOutlined, UploadOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, DatePicker, Select, Button, Checkbox, Table, Space, FormInstance, Spin, Tooltip, Modal, Upload, Progress } from "antd";
import "./purchase_request.css";
import withPurchaseRequestLogic from "../../components/hoc_purchase_request";
import axios from "axios";

interface PurchaseRequestProps {
    form?: FormInstance;
    dealerOptions?: { value: string; label: string }[];
    columns?: { title: string; dataIndex: string }[];
    showModal?: () => void;
    onCancelModal?: () => void;
    onAddItem?: (item: any) => void;
    isModalVisible?: boolean;
    items?: any[];
    onRowSelection?: (selectedRowKeys: React.Key[], selectedRows: any[]) => void;
    selectedRowKeys?: React.Key[];
    onDelete?: () => void;
    onEditItem?: (item: any) => void;
    editItem?: any;
    onRowDoubleClick?: (record: any) => void;
    onSave?: () => void;
    isSaving?: boolean;
    confirmSave?: () => void;
    isLoadingData?: boolean;
    confirmSubmit?: () => void;
    isSubmitted?: boolean;
    brandOptions?: { value: string; label: string }[];
    profitCenterOptions?: { value: string; label: string }[];
    orderTypeOptions?: { value: string; label: string }[];
    onItemGroupChange?: (value: string) => void;
    autosaveStatus?: 'idle' | 'processing' | 'error' | 'stopped';
    handlePrintReport?: () => void;
    confirmVoid?: () => void;
    isVoidDisabled?: boolean;
    statusValue?: string | number;
    onNew?: () => void;
    isPrinting?: boolean;
    onImportItems?: (importedItems: any[]) => void;
}
const PurchaseRequest: React.FC<PurchaseRequestProps> = ({
    form,
    dealerOptions,
    columns,
    showModal,
    items,
    onRowSelection,
    selectedRowKeys,
    onDelete,
    onRowDoubleClick,
    onSave,
    isSaving,
    confirmSave,
    isLoadingData,
    confirmSubmit,
    isSubmitted,
    brandOptions,
    profitCenterOptions,
    orderTypeOptions,
    onItemGroupChange,
    autosaveStatus,
    handlePrintReport,
    confirmVoid,
    isVoidDisabled,
    statusValue,
    onNew,
    isPrinting,
    onImportItems

}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const [isUploadModalVisible, setIsUploadModalVisible] = React.useState(false);
    const [isDownloadingTemplate, setIsDownloadingTemplate] = React.useState(false);
    const [fileList, setFileList] = React.useState<any[]>([]);
    const [isProcessingUpload, setIsProcessingUpload] = React.useState(false);
    const [uploadProgress, setUploadProgress] = React.useState<number | null>(null);
    const handleProcessUpload = async () => {
        if (fileList.length === 0) return;
        setIsProcessingUpload(true);
        setUploadProgress(0);
        const formData = new FormData();
        formData.append('file', fileList[0]);
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/purchase-requests/import`, formData, {
                responseType: 'blob'
            });
            const contentType = response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                const text = await response.data.text();
                const result = JSON.parse(text);
                if (result.success && onImportItems) {
                    const total = result.items.length;
                    if (total > 0) {
                        for (let i = 0; i <= total; i++) {
                            setUploadProgress(Math.round((i / total) * 100));
                            if (i < total) {
                                onImportItems([result.items[i]]);
                                await new Promise((resolve) => setTimeout(resolve, 30));
                            }
                        }
                    } else {
                        setUploadProgress(100);
                    }
                    await new Promise((resolve) => setTimeout(resolve, 500));
                    setIsUploadModalVisible(false);
                    setFileList([]);
                }
            } else {
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'failed_part_number_tidak_terdaftar.xls';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Import failed:', error);
        } finally {
            setIsProcessingUpload(false);
            setUploadProgress(null);
        }
    };

    const handleDownloadTemplate = async () => {
        setIsDownloadingTemplate(true);
        try {
            const response = await fetch('/reports/purchase_request_data.xlsx');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'purchase_request_data.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download template failed:', error);
        } finally {
            setIsDownloadingTemplate(false);
        }
    };
    return (
        <Spin spinning={isLoadingData} tip="Memuat data...">
            <div id="iau9" style={transformStyle}>
                <div className="gjs-grid-row" id="igdgt">
                    <div className="gjs-grid-column" id="iux5k">
                        <Breadcrumb
                            items={[
                                {
                                    href: "",
                                    title: <HomeOutlined />,
                                },
                                {
                                    href: "#/dashboard/browser_purchase_request",
                                    title: (
                                        <>
                                            <span>Data Purchase Request</span>
                                        </>
                                    ),
                                },
                                {
                                    title: "Purchase Request",
                                },
                            ]}
                        />
                    </div>
                </div>
                <div className="gjs-grid-row" id="x1uuis">
                    <div className="gjs-grid-column" id="uudia2">
                        <Button className="pr-button" onClick={onNew}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z"
                                    clipRule="evenodd"
                                />
                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                            </svg>
                            New
                        </Button>
                        <Button
                            className="pr-button"
                            onClick={confirmSubmit}
                            disabled={isSubmitted}
                            loading={isSaving}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                    clipRule="evenodd"
                                />
                                <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                            </svg>
                            Submit
                        </Button>
                        <Button className="pr-button" disabled={isVoidDisabled} onClick={confirmVoid}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Void
                        </Button>
                        <Button className="pr-button" onClick={handlePrintReport} disabled={statusValue !== 7 && statusValue !== 4 && statusValue !== 'Ready' && statusValue !== 'Close / Complete'} loading={isPrinting}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Print
                        </Button>
                        <Space style={{ marginLeft: '10px' }}>
                            {autosaveStatus === 'processing' && (
                                <Tooltip title="Autosave sedang berjalan...">
                                    <LoadingOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'error' && (
                                <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                    <WarningOutlined style={{ color: '#ff4d4f' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'stopped' && (
                                <Tooltip title="Autosave dihentikan karena status dokumen tidak 'Draft' atau data utama belum lengkap.">
                                    <StopOutlined style={{ color: '#bfbfbf' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'idle' && (
                                <Tooltip title="Autosave berhasil.">
                                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                </Tooltip>
                            )}
                        </Space>
                    </div>
                </div>
                <div className="gjs-grid-row" id="itgu5">
                    <div className="gjs-grid-column" id="icrgw">
                        <Form
                            form={form}
                            layout="horizontal"
                            style={{ maxWidth: 500 }}
                            labelCol={{ style: { width: '160px', textAlign: "left" } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-purchase-request"
                        >
                            <Form.Item
                                label="Status"
                                name="status"
                                style={{
                                    marginBottom: "5px",
                                }}
                                initialValue="Draft"
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="PR No"
                                name="pr_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="PR Date"
                                name="pr_date"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[{ required: true, message: 'Required !' }]}
                            >
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    placeholder="Select date"
                                    style={{ width: "40%", fontSize: "14px" }}
                                    popupStyle={{ fontSize: "12px" }}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Item Group"
                                name="item_group"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[{ required: true, message: 'Required !' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Item Group"
                                    optionFilterProp="label"
                                    options={[
                                        { value: "", label: "--  Empty --" },
                                        { value: "001", label: "Inventory" },
                                        { value: "002", label: "Out Side Job" },
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                    onChange={onItemGroupChange}
                                    disabled={statusValue !== 'Draft' && statusValue !== 1}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Brand"
                                name="brand"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[{ required: true, message: 'Required !' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Brand"
                                    optionFilterProp="label"
                                    options={brandOptions}
                                    loading={!brandOptions}

                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Profit Center"
                                name="profit_center"
                                rules={[{ required: true, message: 'Required !' }]}
                            >

                                <Select
                                    showSearch
                                    placeholder="Select Profit Center"
                                    optionFilterProp="label"
                                    options={[{ value: "", label: "--  Empty --" },
                                    ...(profitCenterOptions || []),]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item label="Warehouse" name="dealer_rep_code">
                                <Select
                                    showSearch
                                    placeholder="Select Warehouse"
                                    optionFilterProp="label"
                                    options={dealerOptions}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Order Type"
                                name="order_type"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[{ required: true, message: 'Required !' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Order Type"
                                    optionFilterProp="label"
                                    options={[
                                        { value: "", label: "--  Empty --" },
                                        ...(orderTypeOptions || [])
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Expected Arrival"
                                name="expected_arrival"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <DatePicker
                                    format="DD/MM/YYYY HH:mm"
                                    showTime={{ format: "HH:mm" }}
                                    placeholder="Date & Time"
                                    style={{ width: "50%", fontSize: "14px" }}
                                    popupStyle={{ fontSize: "12px" }}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Remark"
                                name="remark"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input.TextArea rows={4} placeholder="Enter your remarks here..." />
                            </Form.Item>
                        </Form>

                    </div>
                    <div className="gjs-grid-column" id="ic09k"></div>
                </div>

                <div className="gjs-grid-row" id="iv5g1">
                    <div className="gjs-grid-column" id="i7tcz">
                        <Table
                            scroll={{ x: 900 }}
                            columns={columns}
                            dataSource={items}
                            rowKey="item_code"
                            rowSelection={{
                                type: 'checkbox',
                                selectedRowKeys: selectedRowKeys,
                                onChange: onRowSelection,
                            }}
                            onRow={(record) => ({
                                onDoubleClick: () => onRowDoubleClick?.(record)
                            })}
                            loading={isSaving}
                        />
                        <div style={{ marginTop: "20px", textAlign: "left" }}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={showModal}
                                    disabled={isSubmitted}
                                    style={{
                                        height: "40px",
                                        width: "105px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    }
                                >
                                    Add Line
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={onDelete}
                                    disabled={isSubmitted || !selectedRowKeys || selectedRowKeys.length === 0}
                                    style={{
                                        height: "40px",
                                        width: "90px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}
                                        >
                                            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                        </svg>
                                    }
                                >
                                    Delete
                                </Button>
                                <Button
                                    type="primary"
                                    disabled={isSubmitted || autosaveStatus === 'stopped'}
                                    style={{
                                        height: "40px",
                                        width: "105px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={<UploadOutlined />}
                                    onClick={() => setIsUploadModalVisible(true)}
                                >
                                    Upload
                                </Button>
                                <Button
                                    type="primary"
                                    disabled={isSubmitted}
                                    loading={isDownloadingTemplate}
                                    onClick={handleDownloadTemplate}
                                    style={{
                                        height: "40px",
                                        width: "190px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={
                                        !isDownloadingTemplate && (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                style={{ width: "22px", height: "22px" }}
                                            >
                                                <path fillRule="evenodd" d="M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V10.5Z" clipRule="evenodd" />
                                            </svg>
                                        )
                                    }
                                >
                                    Download Template
                                </Button>

                            </Space>
                        </div>

                    </div>
                </div>
                <Modal
                    title="Import File"
                    open={isUploadModalVisible}
                    onCancel={() => !isProcessingUpload && setIsUploadModalVisible(false)}
                    footer={[
                        <Button key="close" disabled={isProcessingUpload} onClick={() => setIsUploadModalVisible(false)}>
                            Close
                        </Button>,
                        <Button key="process" type="primary" loading={isProcessingUpload} disabled={fileList.length === 0} onClick={handleProcessUpload}>
                            Proses
                        </Button>
                    ]}
                >
                    <p style={{ marginBottom: "16px" }}>Import file only excel, xls, xlsx</p>
                    <Upload.Dragger
                        accept=".xls,.xlsx"
                        beforeUpload={(file) => { setFileList([file]); return false; }}
                        fileList={fileList}
                        onRemove={() => setFileList([])}
                        multiple={false}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined style={{ color: "#1890ff", fontSize: "48px" }} />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">Support for a single .xls or .xlsx file.</p>
                    </Upload.Dragger>
                    {fileList.length > 0 && uploadProgress !== null && (
                        <div style={{ marginTop: '12px' }}>
                            <Progress percent={uploadProgress} status="active" />
                        </div>
                    )}
                </Modal>
            </div>
        </Spin>
    );
};

export default withPurchaseRequestLogic(PurchaseRequest);